import MoreToneIcon, { MoreToneIcon as NotPureMoreToneIcon } from './MoreToneIcon';
import * as Types from './MoreToneIcon.d';
import { StyledMoreToneIcon } from './MoreToneIcon.styled';

export { NotPureMoreToneIcon as MoreToneIcon, StyledMoreToneIcon };
export type MoreToneIconProps = Types.MoreToneIconProps;
export default MoreToneIcon;
